import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { onChangeLanguageOrZipCodeFillCityStateInShippingAddresses } from '../helpers/locateCityState';
import { validateFields } from '../helpers/validateFields';
import ClipLoader from 'react-spinners/ClipLoader';
import { css } from '@emotion/core';
import InputAdornment from '@material-ui/core/InputAdornment';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: gray;
`;


const useStyles = makeStyles(theme => ({
    dense: {
        marginTop: theme.spacing(2),
        backgroundColor: 'white',
    },
}));

const ShippingAddress = (props) => {

    const classes = useStyles();

    const [fieldsDisable, setFieldsDisable] = useState(true);

    const [zipCodeRequired, setZipCodeRequired] = useState(false);
    const [addressLine1Required, setAddressLine1Required] = useState(false);
    const [countryRequired, setCountryRequired] = useState(false);
    const [cityRequired, setCityRequired] = useState(false);
    const [stateRequired, setStateRequired] = useState(false);
    const [zipCodeLoading, setZipCodeLoading] = useState(false);

    return (
        <Grid container spacing={1} justify="space-between">
            <Grid item xs={12} sm={12}>
                <h2>Shipping Address:</h2>
            </Grid>
            <Grid item xs={12} sm={6}>
                {(zipCodeRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* Required</label> : <label></label>}
                <TextField id="shippingPostalCode"
                    label="ZIP Code"
                    InputLabelProps={{ shrink: true }}
                    className={classes.dense}
                    error={zipCodeRequired}
                    margin="dense"
                    variant="outlined"
                    style={{ marginTop: zipCodeRequired ? '3px' : '16px', }}
                    onInput={async(e) => {
                        const patternOnlyNumber = /\d+/g;
                        if (String(e.target.value) !== "") {
                            var newValue = (String(e.target.value).match(patternOnlyNumber) !== null) ? String(e.target.value).match(patternOnlyNumber)[0] : '';
                            e.target.value = Number(newValue);
                        } else {
                            e.target.value = '';
                        }
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onChange={async () => {
                        setZipCodeLoading(true);
                        await onChangeLanguageOrZipCodeFillCityStateInShippingAddresses()
                        setFieldsDisable(false);
                        setZipCodeLoading(false);
                    }}
                    onBlur={async(e) => {
                        (e.target.value.length > 0) ? setZipCodeRequired(false) : setZipCodeRequired(true);
                        const isValid = await validateFields(); props.setButtonDisabled(isValid);
                    }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end"> <ClipLoader
                        css={override}
                        sizeUnit={"px"}
                        size={15}
                        loading={zipCodeLoading}
                    /></InputAdornment>,
                      }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={6}>
                {(addressLine1Required) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* Required</label> : <label></label>}
                <TextField id="shippingAddressLine1"
                    label="Address Line 1"
                    error={addressLine1Required}
                    InputLabelProps={{ shrink: true }}
                    className={classes.dense}
                    margin="dense"
                    variant="outlined"
                    disabled={fieldsDisable}
                    style={{ marginTop: addressLine1Required ? '3px' : '16px', }}
                    onInput={async(e) => {
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => {
                        (e.target.value.length > 0) ? setAddressLine1Required(false) : setAddressLine1Required(true);
                        const isValid = await validateFields(); props.setButtonDisabled(isValid);
                    }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={6}>
                <label style={{ fontSize: '12px', float: 'right', }}>* Optional</label>
                <TextField id="shippingAddressLine2"
                    label="Address Line 2"
                    className={classes.dense}
                    margin="dense"
                    variant="outlined"
                    disabled={fieldsDisable}
                    style={{ marginTop: '3px', }}
                    onInput={async(e) => {
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={6}>
                {(countryRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* Required</label> : <label></label>}
                <TextField id="shippingCountry"
                    label="Country"
                    error={countryRequired}
                    InputLabelProps={{ shrink: true }}
                    className={classes.dense}
                    margin="dense"
                    disabled={fieldsDisable}
                    variant="outlined"
                    style={{ marginTop: countryRequired ? '3px' : '16px', }}
                    onInput={async(e) => {
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => {
                        (e.target.value.length > 0) ? setCountryRequired(false) : setCountryRequired(true);
                        const isValid = await validateFields(); props.setButtonDisabled(isValid);
                    }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={6}>
                {(cityRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* Required</label> : <label></label>}
                <TextField id="shippingCity"
                    label="City"
                    error={cityRequired}
                    InputLabelProps={{ shrink: true }}
                    className={classes.dense}
                    margin="dense"
                    disabled={fieldsDisable}
                    variant="outlined"
                    style={{ marginTop: cityRequired ? '3px' : '16px', }}
                    onInput={async(e) => {
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => {
                        (e.target.value.length > 0) ? setCityRequired(false) : setCityRequired(true);
                        const isValid = await validateFields(); props.setButtonDisabled(isValid);
                    }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={6}>
                {(stateRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* Required</label> : <label></label>}
                <TextField id="shippingState"
                    InputLabelProps={{ shrink: true }}
                    label="State"
                    error={stateRequired}
                    className={classes.dense}
                    margin="dense"
                    disabled={fieldsDisable}
                    variant="outlined"
                    style={{ marginTop: stateRequired ? '3px' : '16px', }}
                    onInput={async(e) => {
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => {
                        (e.target.value.length > 0) ? setStateRequired(false) : setStateRequired(true);
                        const isValid = await validateFields(); props.setButtonDisabled(isValid);
                    }}
                    fullWidth={true} />
            </Grid>
        </Grid>
    )
};

export default ShippingAddress;